export interface NonProductiveCategoryOption {
  id: string;
  name: 'admin' | 'leave' | 'study_leave' | 'public_holiday';
  label: string;
}

export const NON_PRODUCTIVE_CATEGORY_OPTIONS: NonProductiveCategoryOption[] = [
  {
    id: 'd4e5f6a7-b8c9-0123-def1-234567890123',
    name: 'admin',
    label: 'Admin / Meetings',
  },
  {
    id: 'a1b2c3d4-e5f6-7890-abcd-ef1234567890',
    name: 'leave',
    label: 'Leave',
  },
  {
    id: 'b2c3d4e5-f6a7-8901-bcde-f12345678901',
    name: 'study_leave',
    label: 'Study Leave / Training',
  },
  {
    id: 'c3d4e5f6-a7b8-9012-cdef-123456789012',
    name: 'public_holiday',
    label: 'Public Holiday',
  },
];

export const getNonProductiveCategoryLabel = (categoryId: string): string => {
  const match = NON_PRODUCTIVE_CATEGORY_OPTIONS.find(option => option.id === categoryId);
  return match ? match.label : 'Other';
};
